import { mapGetters, mapMutations } from 'vuex';
import { planTypes, AUTO_ADD_BASE_PLAN_CODES, AUDIO_SUB_TYPES } from '@/common/constants';
import { AddOrRemoveBasePlanActionTypes } from '../constants';
import { getPlanTotalLicense } from '@/common/service/validate';
import { pageConfig } from '@/common/service/page-config';
import { getPlanTypeByCategory } from '@/common/service/parse';
import switchBasePlanDialog from '@/components/switch-base-plan-dialog';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import { isBuyingWnE } from '@/plans/ZOOM_MEETING/common/utils';
import { debounce } from 'lodash';

export default {
  data() {
    return {
      title: '',
      msgInstance: null,
      visibleCapacityList: [],
      hasModifyCapacity: false,
      switchBasePlanDialog: new ServiceConfirm(switchBasePlanDialog),
    };
  },
  computed: {
    ...mapGetters([
      'getCurrentMeetingPlans',
      'currentEditPlan',
      'getBoughtMeetingPlans',
      'getCurrentBasePlanInfo',
      'getSelectedPlans',
      'fromCampaignLink',
      'plancodeMapSubscriptionDisabled',
      'boughtPlans',
      'basicConfig',
      'unSelectedPlanLicense',
      'isOnlineFreeTrailAccount'
    ]),
    currentBasePlans() {
      return this.getCurrentMeetingPlans.length ? this.getCurrentMeetingPlans : this.getCurrentBasePlanInfo?.plans;
    },
    mx_getBoughtOrBuyingBasePlans() {
      const boughtMeetingPlans = this.getCurrentMeetingPlans;
      const {
        category: basePlanCategory,
        billing_cycle: basePlanBillingCycle,
        planNameKey,
        typeNameKey,
        type: basePlanType,
        max: maxHosts,
      } = boughtMeetingPlans[0] || this.currentBasePlans[0];
      const basePlanName = this.$t(planNameKey) || this.$t(typeNameKey);
      const currentBasePlanQuantity = boughtMeetingPlans[0] ? getPlanTotalLicense(boughtMeetingPlans) : 0;
      return {
        basePlanCategory,
        basePlanBillingCycle,
        basePlanType,
        basePlanName,
        planNameKey,
        typeNameKey,
        currentBasePlanQuantity,
        maxHosts
      };
    },
    mx_getBoughtOrBuyingSelectedPlans() {
      const { from } = pageConfig;
      const planType = this.planType || getPlanTypeByCategory(from);
      const targetPlan = this.getSelectedPlans.filter(item => item.type == planType);
      if(!targetPlan.length){
        const {
          planNameKey,
          typeNameKey,
        } = this.planList[0]
        return {
          selectedPlanType: this.planType,
          selectedPlanName,
          planNameKey,
          typeNameKey,
        }
      }
    const { maxIndex, maxPlans, maxSelectedNumber }= this.findMaxSelectedNumber(targetPlan);
    const {
      category: selectedPlanCategory,
      billing_cycle: selectedPlanBillingCycle,
      planNameKey,
      typeNameKey,
      type: selectedPlanType,
    } = targetPlan[maxIndex]
    const selectedPlanName = this.$t(planNameKey) || this.$t(typeNameKey);
      const currentSelectedPlanQuantity = targetPlan[maxIndex] ?  ( maxSelectedNumber || this.unSelectedPlanLicense || getPlanTotalLicense(targetPlan)) : 0;
      return {
        selectedPlanCategory,
        selectedPlanBillingCycle,
        selectedPlanType,
        selectedPlanName,
        planNameKey,
        typeNameKey,
        currentSelectedPlanQuantity,
        maxPlans
      };
    },
    mx_currentPlans() {
      const planType = this.configPlanType === planTypes.EVENT_SAAS_CORE ? this.configPlanType : this.planType
      return this.selectedPlanList?.filter((item) => item.type === planType) || [];
    },
    mx_plansSortedByMaximumCount() {
      return this.mx_currentPlans.sort(
        (itemPrev, itemNext) => (itemNext.cartInfo?.selected_number || 0) - (itemPrev.cartInfo?.selected_number || 0),
      );
    },
    // For multiple capacities plans to pick the largest license count
    mx_peakCapacityLicenseCount() {
      const peakPlan = this.mx_plansSortedByMaximumCount[0];
      return peakPlan?.cartInfo?.selected_number || 0;
    },
    mx_planLicenseCount() {
      // could be override by specific requirement
      return this.mx_peakCapacityLicenseCount;
    },
    mx_basePlanLicenseCount() {
      const { currentBasePlanQuantity } = this.mx_getBoughtOrBuyingBasePlans;
      return currentBasePlanQuantity
    },
    mx_canAutoAdd() {
      const autoAddBasePlans = this.currentBasePlans.filter((plan) =>
        AUTO_ADD_BASE_PLAN_CODES.includes(plan.plan_code),
      );
      const hasAudioUnlimited = !!this.boughtPlans.find(item => item.type === planTypes.TOLLFREE && item.category === AUDIO_SUB_TYPES.UNLIMITED);
      //isCustomPricing4MajorPlan means multiple pro/biz plan, not include single customer rate plan
      const isMultipleRatePlan = this.basicConfig?.isCustomPricing4MajorPlan;
      const isSingleRateOrSupportMultipleRate = !isMultipleRatePlan || autoAddBasePlans.every((plan) => (plan?.ratePlans?.length > 1));
      const isEnableStatus = autoAddBasePlans.every((plan) => !this.plancodeMapSubscriptionDisabled[plan.plan_code]);
      return (
        isBuyingWnE(this.getSelectedPlans) &&
        autoAddBasePlans.length === 1 &&
        !this.hasModifyCapacity &&
        !this.fromCampaignLink &&
        isSingleRateOrSupportMultipleRate &&
        !hasAudioUnlimited &&
        isEnableStatus
        && !this.isOnlineFreeTrailAccount
      );
    },
  },
  methods: {
    ...mapMutations(['updateSelectPlanByCategory', 'setUpdateBasePlan', 'addOrRemoveBasePlan','setSelectedPlanLicense']),
    mx_checkCapacityChanged(newPlan) {
      const { type: basePlanType } = this.getBoughtMeetingPlans[0] || this.currentBasePlans[0];
      this.hasModifyCapacity = newPlan.category !== this.currentEditPlan.category;
      if (this.hasModifyCapacity) {
        this.addOrRemoveBasePlan({ actionType: AddOrRemoveBasePlanActionTypes.REMOVE, planType: planTypes[basePlanType] });
      }
    },
    mx_plansFilteredByCapacityKey(capacity, capacityKey) {
      return this.mx_currentPlans.filter((item) => item[capacityKey] === capacity);
    },
    // For chosen specific capacity key license count
    mx_totalCapacityLicenseCount(capacity, capacityKey = this.capacityKey) {
      const chosenPlans = this.mx_plansFilteredByCapacityKey(capacity, capacityKey);
      return getPlanTotalLicense(chosenPlans);
    },
    mx_autoSyncSelectedNumber(basePlanCategory, basePlanBillingCycle, basePlanNewSelectorNumber ,basePlanName) {
      this.mx_onBasePlanUpdated(basePlanName)
      this.updateSelectPlanByCategory({
        category: basePlanCategory,
        billingCycle: basePlanBillingCycle,
        cartInfo: { selected_number: basePlanNewSelectorNumber },
      });
      this.$nextTick(() => {
        this.setUpdateBasePlan({ update: true, from: this.title }); // Ensure the triggering of the watch in ZOOM_MEETING/edit.
      });
    },
    mx_autoSyncSelectedPlanNumber(selectedPlanCategory, selectedPlanBillingCycle, selectedPlanNewSelectorNumber,selectedPlanName) {
      const { basePlanName } =
      this.mx_getBoughtOrBuyingBasePlans;
      this.mx_onSelectedPlanUpdated(basePlanName,selectedPlanName)
      if (selectedPlanCategory) {
        this.updateSelectPlanByCategory({
          category: selectedPlanCategory,
          billingCycle: selectedPlanBillingCycle,
          cartInfo: { selected_number: selectedPlanNewSelectorNumber },
        });
      } else {
        this.setSelectedPlanLicense({currentLicense:this.unSelectedPlanLicense
          ,baseLicense:selectedPlanNewSelectorNumber})
      } 
    },
    mx_onBasePlanUpdated() {
      // no-op
    },
    mx_onSelectedPlanUpdated(basePlanName,selectedPlanName) {
      this.mx_showMessage(
        this.$t('billing.license_sync_base', [selectedPlanName,basePlanName]),
      );
    },
    mx_showMessage(message) {
      this.msgInstance && this.msgInstance.close();
      this.msgInstance = this.$message({
        type: 'info',
        duration: 5000,
        message: message,
        showClose: true
      })
    },
    mx_handlePlanLicenseChange(nv){
      const { basePlanCategory, basePlanBillingCycle, basePlanName, currentBasePlanQuantity,maxHosts } =
       this.mx_getBoughtOrBuyingBasePlans;
       if(nv > maxHosts){
        this.msgInstance && this.msgInstance.close();
        this.switchBasePlanDialog.confirm({sourcePlan: this.mx_getBoughtOrBuyingBasePlans,
          targetPlan: this.mx_getBoughtOrBuyingSelectedPlans,
          currentLicense: nv,
        })
      } else {
        if (nv > currentBasePlanQuantity) {
          this.mx_autoSyncSelectedNumber(basePlanCategory, basePlanBillingCycle, nv,basePlanName);
        }
      }
    },
    mx_handleBasePlanLicenseChange(nv){
      const { selectedPlanCategory, selectedPlanBillingCycle, selectedPlanName ,currentSelectedPlanQuantity ,maxPlans } =
      this.mx_getBoughtOrBuyingSelectedPlans;
      const currentLicense = currentSelectedPlanQuantity || this.unSelectedPlanLicense
      if(maxPlans && maxPlans.length){
        maxPlans.map(m=>{
          const { category , billing_cycle,   
            planNameKey  } = m
          if(category){
            if(nv < currentLicense){
              this.mx_autoSyncSelectedPlanNumber(
                category || selectedPlanCategory,
                billing_cycle || selectedPlanBillingCycle,
                nv, 
                this.$t(planNameKey) || selectedPlanName
              )
            }
          }       
        })
      } else {
        if(nv < currentLicense){
          this.mx_autoSyncSelectedPlanNumber(selectedPlanCategory, selectedPlanBillingCycle, nv ,selectedPlanName)
        }
      }
    },
    findMaxSelectedNumber(targetPlan) {   
      let maxSelectedNumber = targetPlan[0].cartInfo.selected_number
      let maxIndex = [0]

      targetPlan.forEach(function(obj, index) {
        if (obj.cartInfo && obj.cartInfo.selected_number !== undefined) {
            if (obj.cartInfo.selected_number > maxSelectedNumber) {
                maxSelectedNumber = obj.cartInfo.selected_number;
                maxIndex = [index]
            } else if (obj.cartInfo.selected_number === maxSelectedNumber && index !== maxIndex[0]) {
                maxIndex.push(index);
            }
        }
    });

    let maxPlans = maxIndex.map(index => targetPlan[index]);

    return {
        maxSelectedNumber: maxSelectedNumber,
        maxIndex: maxIndex[0],
        maxPlans: maxPlans
    };
  },
  findUpdatedPlan(arr1, arr2)  {
    const updatedPlanInfo = arr1.find(({ category }) => !arr2.some(obj2 => obj2.category === category));
    return updatedPlanInfo ? updatedPlanInfo.cartInfo.selected_number : null;
  }
  },
  watch: {
    mx_planLicenseCount: {
      immediate: true,
      handler: debounce(function (nv) {
        if (!this.mx_canAutoAdd) return;
        this.mx_handlePlanLicenseChange(nv)
      }, 100),
    },
    mx_basePlanLicenseCount:{
      immediate: false,
      handler: debounce(function (nv) {
        if (!this.mx_canAutoAdd) return;
        this.mx_handleBasePlanLicenseChange(nv)
      }, 500),
    }
  },
};
